import { render } from "./UploadVideoV2.vue?vue&type=template&id=03178a95&scoped=true"
import script from "./UploadVideoV2.vue?vue&type=script&lang=js"
export * from "./UploadVideoV2.vue?vue&type=script&lang=js"

import "./UploadVideoV2.vue?vue&type=style&index=0&id=03178a95&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03178a95"]])

export default __exports__